import React, { useEffect, useRef, useState } from "react";
import { Copy, ArrowLeft, Download, Eye } from "lucide-react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { AFFILIATE_CONSTANTS } from "../../sharedfiles/Constants";
import { getFromLocalStorage } from "../../sharedfiles/helper";
import { getCampaignURL } from "../Affiliate/AffiliateSlice";
import NoDataFound from "../Common/table/NoDataFound";
import QRpopUp from "./QRpopUp";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/table";
import { Button } from "../../ui/button";
import { cn } from "../../lib/utils";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";
function CampaignURL(props) {
  const [open, setOpen] = useState(false)
  const [qrCode, setQrCode] = useState('')
  const [copiedIndex, setCopiedIndex] = useState(null)
  const dispatch = useDispatch();
  const history = useHistory();
  const urlRefs = useRef([]);
  const listURL = useSelector((st) => st.affiliateSlice.campaignURLlist?.urls);
  const campaignId = getFromLocalStorage("campaignId");
  useEffect(() => {
    dispatch(getCampaignURL(campaignId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId]);

  const copyText = (url, index) => {
    navigator.clipboard.writeText(url);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  const viewQRcode = (qrcode) => {
    setQrCode(qrcode)
    setOpen(true)
  }

  const onClose = (isOpen) => {
    setOpen(isOpen)
  }

  const campaignUrlHeaders = [
    AFFILIATE_CONSTANTS.header_channelName,
    AFFILIATE_CONSTANTS.header_URL,
    AFFILIATE_CONSTANTS.header_QRcode,
    AFFILIATE_CONSTANTS.copy_URL,
  ];
  const campaignUrlRowAccessors = [
    (item) => item.channelName,
    (item) => (
      <div className="max-w-md truncate" title={item.url}>
        {item.url}
      </div>
    ),
    (item, ind) => (
      <div className="flex items-center justify-center gap-2">
        <Button
          variant="outline"
          size="sm"
          asChild
          className="gap-2"
        >
          <a href={item?.qrcode} download>
            <Download size={16} />
            Download
          </a>
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={() => viewQRcode(item?.qrcode)}
          className="gap-2"
        >
          <Eye size={16} />
          View
        </Button>
      </div>
    ),
    (item, ind) => (
      <div className="flex items-center justify-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => copyText(item.url, ind)}
          className="relative"
        >
          <Copy size={16} />
        </Button>
        {copiedIndex === ind && (
          <span className="text-sm text-green-600 dark:text-green-400 font-medium animate-in fade-in">
            Copied!
          </span>
        )}
      </div>
    ),
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("campaignCampaignURL", campaignUrlHeaders);

  return (
    <React.Fragment>
      <QRpopUp
        QRcode={qrCode}
        Open={open}
        Close={onClose}
      />
      <div className='space-y-6'>
        {/* Back Navigation */}
        <div className='flex items-center gap-3'>
          <Button
            variant="outline"
            size="sm"
            onClick={() => history.goBack()}
            className="gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Button>
        </div>

        {/* Campaign URLs Table */}
        <div className='rounded-lg border bg-card shadow-lg overflow-hidden'>
          <div className='bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
            <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Campaign URLs</h2>
            <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>View and manage campaign URLs with QR codes</p>
          </div>
          <div className='relative overflow-x-auto'>
            <TableToolbar
              columns={allColumns}
              onToggle={toggleVisibility}
              onReorder={reorder}
              onReset={resetToDefault}
            />
            <Table scrollKey="campaignCampaignURL">
              <TableHeader>
                <TableRow>
                  {visibleIndices.map((origIdx) => (
                    <TableHead key={origIdx} className="text-center">{campaignUrlHeaders[origIdx]}</TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {listURL &&
                  Array.isArray(listURL) &&
                  listURL.length > 0 ? (
                  listURL?.map((item, ind) => {
                    return (
                      <TableRow key={item.url}>
                        {visibleIndices.map((origIdx) => (
                          <TableCell key={origIdx} className={cn("text-center", origIdx === 0 && "font-medium", origIdx === 1 && "font-mono text-sm")}>
                            {campaignUrlRowAccessors[origIdx](item, ind)}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })
                ) : (
                  <NoDataFound colspan={visibleIndices.length} />
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CampaignURL;
